import { render, staticRenderFns } from "./ImportClasses.vue?vue&type=template&id=eabb3406&scoped=true&"
import script from "./ImportClasses.vue?vue&type=script&lang=js&"
export * from "./ImportClasses.vue?vue&type=script&lang=js&"
import style0 from "./ImportClasses.vue?vue&type=style&index=0&id=eabb3406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabb3406",
  null
  
)

export default component.exports